import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TranslatedText from "./TranslatedText";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import myRestClient from "../common/restClient";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import FileCopyOutlinedIcon from "@material-ui/icons/ContentCopy";
import DesktopWindowsIcon from "@material-ui/icons/DesktopWindows";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Tooltip from "@material-ui/core/Tooltip";
import Snackbar from "@material-ui/core/Snackbar";
import copy from "copy-to-clipboard";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import { POLICY_INSTALLATIONS } from "../common/rolesManagement";
import RefreshListActions from "../resources/Installations/RefreshListActions";
import IconRocket from "../common/icons/svgRocket";
import DeleteIcon from "@material-ui/icons/Delete";
import { showNotification } from "ra-core";
import { getInstallationTypeId } from "../common/utilities";

import {
    HELK_DASHBOARD_CLUSTER_SYSTEM,
    HELK_DASHBOARD_CLUSTER_DOCKER,
    HELK_DASHBOARD_CUSTOMER_OVERVIEW,
    HELK_DASHBOARD_CUSTOMER_START,
    HELK_DASHBOARD_SYSERR,
    API_URL
} from "../config";

class DetailsDialogButton extends React.Component {
    state = {
        open: false,
        loading: true,
        info: null,
        snackBar: false,
        menuAnchor: null,
        showDB: false,
        showContainer: false,
        studio_id: null,
        enterprise_id: null,
        operation: [],
        assistance: {
            status: "CARICAMENTO",
            id: null,
            openConfirmationDialog: false,
            confirmInProgress: false,
            openCancellationDialog: false,
            cancellationInProgress: false
        }
    };
    componentDidMount = () => {
        getInstallationTypeId("STUDIO").then(inst_id =>
            this.setState({ studio_id: inst_id })
        );
        getInstallationTypeId("ENTERPRISE").then(inst_id =>
            this.setState({ enterprise_id: inst_id })
        );
    };
    refreshAssistanceStatus = async () => {
        myRestClient("GET_ONE_BY_PARAMETERS", "database-support", {
            installation_id: this.props.data.id
        }).then(
            r => {
                console.log(r.data);
                this.setState({
                    assistance: {
                        status: r.data.status,
                        id: r.data.id
                    }
                });
            },
            e => {
                this.setState({
                    assistance: {
                        status: "ERRORE",
                        id: null
                    }
                });
            }
        );
    };

    handleClickOpen = async () => {
        this.setState({ open: true, loading: true });

        if (this.props.data) {
            const params = {
                id: this.props.data.id
            };
            await myRestClient("GET_ONE", "installation-info", params).then(
                response => {
                    this.setState({
                        info: response.data,
                        loading: false
                    });
                },
                err => {
                    this.setState({
                        info: err,
                        loading: false
                    });
                }
            );
            if (
                this.props.data.installation_type_id ===
                this.state.enterprise_id
            ) {
                await this.refreshAssistanceStatus();
                this.assistanceInterval = setInterval(() => {
                    this.refreshAssistanceStatus();
                }, 20000);
            }
        }
    };

    handleClose = () => {
        this.setState({ open: false });
        clearInterval(this.assistanceInterval);
    };

    myDialog() {
        const info = this.state.info;
        return (
            <React.Fragment>
                {info && this.renderInfoTable(info)}
                {!info && "Cannot load"}
            </React.Fragment>
        );
    }

    renderInfoTable(info) {
        let translatedInfo = this.translateInfo(info);
        let keys = Object.keys(translatedInfo);
        keys.sort();
        return (
            <Table>
                <TableBody>
                    {keys.map(key => (
                        <TableRow key={key}>
                            <TableCell>
                                <b>{key}</b>
                            </TableCell>
                            <TableCell>{translatedInfo[key]}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    translateInfo(info) {
        let result = {};
        Object.keys(info).map(key => {
            return (result[this.renderKey(key)] =
                this.decodeValues(key, info[key]) +
                this.renderUnitOfMeasurement(key));
        });
        return result;
    }

    decodeValues(key, value) {
        const stringValue = value + "";
        switch (key) {
            case "customer_type":
                switch (stringValue) {
                    case "m":
                        return "Migrazione";
                    case "n":
                        return "Nuova installazione";
                    default:
                        return stringValue;
                }
            case "http_status":
                switch (stringValue) {
                    case "1":
                        return "Attivo";
                    case "0":
                        return "Non attivo";
                    default:
                        return stringValue;
                }
            case "sys_hard":
                switch (stringValue) {
                    case "true":
                        return "Hard";
                    case "false":
                        return "Soft";
                    default:
                        return stringValue;
                }
            case "update":
                switch (stringValue) {
                    case "0":
                        return "SI";
                    case "1":
                        return "NO";
                    default:
                        return stringValue;
                }
            case "has_studio_license":
            case "has_studio_license_not_valid":
            case "has_azienda_license":
            case "has_azienda_license_not_valid":
            case "has_tu_license":
            case "has_studio_manager":
            case "has_hr_license":
            case "has_hr_license_not_valid":
            case "has_studio_manager_used":
            case "ctree_activated":
                switch (stringValue) {
                    case "true":
                        return "SI";
                    case "false":
                        return "NO";
                    default:
                        return stringValue;
                }
            default:
                return stringValue;
        }
    }

    renderKey(key) {
        switch (key) {
            case "volume_state":
                return "DISK: stato";
            case "customer_type":
                return "Tipo installazione";
            case "sys_ram":
                return "SYS: RAM riservata";
            case "redis_db":
                return "REDIS: Numero Database";
            case "uas":
                return "TSEXP: Pdl";
            case "installation_id":
                return "ID Installazione";
            case "rds_host":
                return "RDS: Hostname";
            case "status":
                return "ECS: Stato servizio";
            case "desired_count":
                return "ECS: Numero container desiderato";
            case "http_port":
                return "HTTP: Porta interna";
            case "redis_host":
                return "REDIS: Hostname";
            case "url":
                return "TSEXP: Portale Url";
            case "volume_pused":
                return "DISK: percentuale uso";
            case "http_status":
                return "HTTP: Stato servizio";
            case "company":
                return "P.IVA Azienda";
            case "image":
                return "DOCKER: Immagine";
            case "cluster_private_ip":
                return "CLUSTER: IP Privato";
            case "sys_cpu":
                return "SYS: CPU";
            case "running_count":
                return "ECS: Numero container running";
            case "version":
                return "TSEXP: Versione";
            case "rds_user":
                return "RDS: Utente";
            case "volume_name":
                return "DISK: nome";
            case "cluster_name":
                return "CLUSTER: Nome";
            case "rds_db_tse":
                return "RDS: DB TSExperience";
            case "volume_size":
                return "DISK: dimensione";
            case "update":
                return "TSEXP: Aggiornabilità";
            case "ctree_port":
                return "CTREE: Porta interna";
            case "ctree_activated":
                return "CTREE attivo";
            case "alb":
                return "ALB";
            case "sys_hard":
                return "SYS: Tipologia";
            case "customer":
                return "Codice cliente";
            case "volume_mount_point":
                return "DISK: percorso";
            case "type":
                return "Tipologia cliente";
            case "cluster_instance_id":
                return "CLUSTER: Instance ID";
            case "base_license_release_date":
                return "TSEXP: Data rilascio licenza base (5008)";
            case "container_id":
                return "DOCKER: ID";
            case "created":
                return "Data creazione";
            case "has_studio_manager":
                return "Ha licenze STUDIO Manager";
            case "last_modified":
                return "Data ultima variazione";
            case "sys_ram_limit":
                return "SYS: RAM Limite massimo";
            case "has_studio_license":
                return "Ha licenze Studio (5060)";
            case "has_studio_license_not_valid":
                return "Lic. Studio non SaaS o scaduta";
            case "has_azienda_license":
                return "Ha licenze Azienda (5066)";
            case "has_azienda_license_not_valid":
                return "Licenze Azienda non SaaS o scaduta";
            case "has_tu_license":
                return "Ha licenze TU";
            case "application_user_last_login":
                return "Ultimo login";
            case "has_hr_license":
                return "Ha licenze HR";
            case "has_hr_license_not_valid":
                return "Licenze HR non SaaS o scadute";
            case "has_studio_manager_used":
                return "Usa STUDIO Manager";
            case "has_beleader":
                return "Ha aziende BeLeader";
            case "piva_cf_cliente":
                return "piva/cf cliente (licenza)";
            case "piva_cf_rivenditore":
                return "piva/cf azienda (licenza)";
            default:
                return key;
        }
    }

    renderUnitOfMeasurement(key) {
        switch (key) {
            case "sys_ram":
            case "sys_ram_limit":
                return " MB";
            case "uas":
                return " PDL";
            case "volume_pused":
                return "%";
            case "volume_size":
                return " GB";
            case "sys_cpu":
                return " crediti";
            default:
                return "";
        }
    }

    renderSSHButtons(instance_id) {
        return (
            <Tooltip title="Apri sessione SSH in una nuova finestra">
                <Button
                    color="primary"
                    target="_blank"
                    onClick={() => {
                        window.open(
                            "https://eu-west-1.console.aws.amazon.com/systems-manager/session-manager/" +
                                instance_id +
                                "?region=eu-west-1",
                            "_blank"
                        );
                    }}
                >
                    <DesktopWindowsIcon />
                </Button>
            </Tooltip>
        );
    }
    renderCopySSHCommand(instance_id) {
        return (
            <Tooltip title="Copia comando terminale">
                <Button
                    color="primary"
                    target="_blank"
                    onClick={() => {
                        copy("aws ssm start-session --target " + instance_id);
                        this.setState({
                            snackBar: true
                        });
                    }}
                >
                    <FileCopyOutlinedIcon />
                </Button>
            </Tooltip>
        );
    }

    renderMoreOptionsMenu(data) {
        const handleOpenMenu = event => {
            this.setState({
                menuAnchor: event.currentTarget
            });
        };

        const handleCloseMenu = () => {
            this.setState({
                menuAnchor: null
            });
        };

        const showContainerDialog = () => {
            console.log("show");
            this.setState({
                menuAnchor: null,
                showContainer: true
            });
        };

        const showDBDialog = () => {
            console.log("show");
            this.setState({
                menuAnchor: null,
                showDB: true
            });
        };

        const openClusterMonitoringSystem = () => {
            this.setState({
                menuAnchor: null
            });
            window.open(
                "https://helk.ts-paas.com/s/studio/app/kibana#/dashboard/" +
                    HELK_DASHBOARD_CLUSTER_SYSTEM +
                    "?_a=(query:(language:kuery,query:%27cluster_name.keyword:%22" +
                    this.state.info.cluster_name +
                    "%22%27))",
                "_blank"
            );
        };

        const openClusterMonitoringDocker = () => {
            this.setState({
                menuAnchor: null
            });
            window.open(
                "https://helk.ts-paas.com/s/studio/app/kibana#/dashboard/" +
                    HELK_DASHBOARD_CLUSTER_DOCKER +
                    "?_a=(query:(language:kuery,query:%27cluster_name.keyword:%22" +
                    this.state.info.cluster_name +
                    "%22%27))",
                "_blank"
            );
        };

        const openCustomerMeteringOverview = () => {
            this.setState({
                menuAnchor: null
            });
            window.open(
                "https://helk.ts-paas.com/s/studio/app/kibana#/dashboard/" +
                    HELK_DASHBOARD_CUSTOMER_OVERVIEW +
                    "?_a=(query:(language:kuery,query:'container_name.keyword:%22" +
                    this.state.info.customer +
                    "%22'))",
                "_blank"
            );
        };

        const openCustomerMeteringStart = () => {
            this.setState({
                menuAnchor: null
            });
            window.open(
                "https://helk.ts-paas.com/s/studio/app/kibana#/dashboard/" +
                    HELK_DASHBOARD_CUSTOMER_START +
                    "?_a=(query:(language:kuery,query:'container_name.keyword:%22" +
                    this.state.info.customer +
                    "%22'))",
                "_blank"
            );
        };

        const openSystemErrors = () => {
            this.setState({
                menuAnchor: null
            });
            const env = API_URL.includes("dev")
                ? "dev"
                : API_URL.includes("staging")
                ? "staging"
                : "prod";
            window.open(
                "https://helk.ts-paas.com/s/studio/app/dashboards#/view/" +
                    HELK_DASHBOARD_SYSERR +
                    "?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1d,to:now))&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'tcc.id%20:%20" +
                    this.props.data.id +
                    "%20and%20tags.keyword%20:%20%22" +
                    env +
                    "%22'),timeRestore:!f,title:'System%20Error%20Messages',viewMode:view)",
                "_blank"
            );
        };

        return (
            <div style={{ display: "inline-block" }}>
                <Tooltip title="Altro">
                    <Button color="primary" onClick={handleOpenMenu}>
                        <MoreVertIcon />
                    </Button>
                </Tooltip>
                <Menu
                    id="simple-menu"
                    anchorEl={this.state.menuAnchor}
                    keepMounted
                    open={this.state.menuAnchor != null ? true : false}
                    onClose={handleCloseMenu}
                >
                    {this.props.permissions.includes(
                        POLICY_INSTALLATIONS.GET_INFO
                    ) && (
                        <MenuItem onClick={showContainerDialog}>
                            Accesso container
                        </MenuItem>
                    )}
                    <Divider />
                    {this.props.permissions.includes(
                        POLICY_INSTALLATIONS.GET_INFO
                    ) && (
                        <MenuItem onClick={showDBDialog}>
                            Accesso database
                        </MenuItem>
                    )}
                    <Divider />
                    <MenuItem onClick={openClusterMonitoringSystem}>
                        Monitoraggio Cluster (system)
                    </MenuItem>
                    <MenuItem onClick={openClusterMonitoringDocker}>
                        Monitoraggio Cluster (docker)
                    </MenuItem>
                    <MenuItem onClick={openCustomerMeteringOverview}>
                        Metering cliente (overview)
                    </MenuItem>
                    <MenuItem onClick={openCustomerMeteringStart}>
                        Metering cliente (START)
                    </MenuItem>
                    <MenuItem onClick={openSystemErrors}>
                        Errori di sistema
                    </MenuItem>
                </Menu>
            </div>
        );
    }

    renderEnterpriseAssistance() {
        const handleOpenConfirmationDialog = event => {
            this.setState({
                assistance: {
                    status: this.state.assistance.status,
                    id: this.state.assistance.id,
                    openConfirmationDialog: true,
                    openCancellationDialog: false
                }
            });
        };
        const handleCancelConfirmationDialog = event => {
            this.setState({
                assistance: {
                    status: this.state.assistance.status,
                    id: this.state.assistance.id,
                    openConfirmationDialog: false,
                    openCancellationDialog: false,
                    confirmInProgress: this.state.assistance.confirmInProgress,
                    cancellationInProgress: this.state.assistance
                        .cancellationInProgress
                }
            });
        };
        const handleOpenCancellationDialog = event => {
            this.setState({
                assistance: {
                    status: this.state.assistance.status,
                    id: this.state.assistance.id,
                    openConfirmationDialog: false,
                    openCancellationDialog: true
                }
            });
        };
        const handleCancelCancellationDialog = event => {
            this.setState({
                assistance: {
                    status: this.state.assistance.status,
                    id: this.state.assistance.id,
                    openConfirmationDialog: false,
                    openCancellationDialog: false,
                    confirmInProgress: this.state.assistance.confirmInProgress,
                    cancellationInProgress: this.state.assistance
                        .cancellationInProgress
                }
            });
        };
        const handleStartProvisioning = event => {
            this.setState({
                assistance: {
                    confirmInProgress: true
                }
            });
            const body = {
                data: {
                    installation_id: this.props.data.id
                }
            };
            myRestClient("CREATE", "database-support", body).then(
                result => {
                    this.setState({
                        assistance: {
                            confirmInProgress: false,
                            openConfirmationDialog: false
                        }
                    });
                    this.refreshAssistanceStatus();
                },
                error => {
                    this.setState({
                        assistance: {
                            confirmInProgress: false,
                            openConfirmationDialog: false
                        }
                    });
                    this.refreshAssistanceStatus();
                    showNotification(error.message);
                }
            );
        };
        const handleDeleteProvisioning = event => {
            this.setState({
                assistance: {
                    cancellationInProgress: true
                }
            });
            const query = {
                id: this.props.data.id
            };
            myRestClient("DELETE", "database-support", query).then(
                result => {
                    this.setState({
                        assistance: {
                            cancellationInProgress: false,
                            openCancellationDialog: false
                        }
                    });
                    this.refreshAssistanceStatus();
                },
                error => {
                    this.setState({
                        assistance: {
                            cancellationInProgress: false,
                            openCancellationDialog: false
                        }
                    });
                    this.refreshAssistanceStatus();
                    showNotification(error.message);
                }
            );
        };
        const statusColor =
            this.state.assistance.status === "ASSENTE"
                ? "#9B9B9B"
                : this.state.assistance.status === "PRONTO"
                ? "#12C51D"
                : this.state.assistance.status === "ERRORE"
                ? "#FF0000"
                : "#F58420";
        return (
            <React.Fragment>
                <Dialog
                    disableBackdropClick
                    disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.assistance.openConfirmationDialog}
                >
                    <DialogTitle>
                        <b>Avvio assistenza</b>
                    </DialogTitle>
                    <DialogContent>
                        Sei sicuro di voler avviare la sessione di assistenza?
                    </DialogContent>
                    <DialogActions>
                        <div
                            align="center"
                            style={{
                                visibility: this.state.assistance
                                    .confirmInProgress
                                    ? "visible"
                                    : "hidden"
                            }}
                        >
                            {<CircularProgress />}
                        </div>
                        {!this.state.assistance.confirmInProgress && (
                            <div>
                                {" "}
                                <Button
                                    onClick={handleCancelConfirmationDialog}
                                    color="primary"
                                >
                                    Annulla
                                </Button>
                                <Button
                                    onClick={handleStartProvisioning}
                                    variant="contained"
                                    color="secondary"
                                >
                                    Ok
                                </Button>
                            </div>
                        )}
                    </DialogActions>
                </Dialog>
                <Dialog
                    disableBackdropClick
                    disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.assistance.openCancellationDialog}
                >
                    <DialogTitle>
                        <b>Termine assistenza</b>
                    </DialogTitle>
                    <DialogContent>
                        Sei sicuro di voler terminare la sessione di assistenza?
                    </DialogContent>
                    <DialogActions>
                        <div
                            align="center"
                            style={{
                                visibility: this.state.assistance
                                    .cancellationInProgress
                                    ? "visible"
                                    : "hidden"
                            }}
                        >
                            {<CircularProgress />}
                        </div>
                        {!this.state.assistance.cancellationInProgress && (
                            <div>
                                {" "}
                                <Button
                                    onClick={handleCancelCancellationDialog}
                                    color="primary"
                                >
                                    Annulla
                                </Button>
                                <Button
                                    onClick={handleDeleteProvisioning}
                                    variant="contained"
                                    color="secondary"
                                >
                                    Ok
                                </Button>
                            </div>
                        )}
                    </DialogActions>
                </Dialog>
                <p
                    style={{
                        color: "#000000",
                        "font-style": "normal",
                        "white-space": "pre-wrap",
                        "font-size": "14px",
                        "margin-bottom": "0px",
                        "margin-left": "10px"
                    }}
                >
                    Accesso diretto al database gestionale
                </p>
                <p
                    style={{
                        "margin-top": "0px",
                        "margin-bottom": "0px"
                    }}
                >
                    <Button
                        color="primary"
                        disabled={true}
                        style={{
                            "padding-top": "0px"
                        }}
                    >
                        <em
                            style={{
                                color: "#000000",
                                "font-style": "normal",
                                "white-space": "pre-wrap"
                            }}
                        >
                            Stato sessione:{" "}
                        </em>
                        <em
                            style={{
                                color: statusColor,
                                "font-style": "normal"
                            }}
                        >
                            {this.state.assistance.status}
                        </em>
                    </Button>
                    <Tooltip
                        disableFocusListener
                        disableTouchListener
                        title="Avvia provisioning assistenza"
                    >
                        <Button
                            color="primary"
                            onClick={handleOpenConfirmationDialog}
                            disabled={
                                this.state.assistance.status !== "ASSENTE"
                            }
                        >
                            <IconRocket />
                        </Button>
                    </Tooltip>
                    <Tooltip
                        disableFocusListener
                        disableTouchListener
                        title="Elimina provisioning assistenza"
                    >
                        <Button
                            color="primary"
                            onClick={handleOpenCancellationDialog}
                            disabled={this.state.assistance.status !== "PRONTO"}
                        >
                            <DeleteIcon />
                        </Button>
                    </Tooltip>
                </p>
            </React.Fragment>
        );
    }
    renderContainerAccessDialog(data) {
        if (!this.state.showContainer) {
            return null;
        }
        const handleCloseContainerAccessDialog = () => {
            this.setState({
                showContainer: false
            });
        };
        const cliCommand =
            "aws ssm start-session --target " +
            data.cluster_instance_id +
            ' --document-name "AWS-StartInteractiveCommand" --parameters "command=sudo docker exec -ti ' +
            data.container_id +
            ' bash"';
        const webCommand =
            "sudo docker exec -ti " + data.container_id + " bash";
        return (
            <Dialog
                maxWidth={false}
                open={this.state.showContainer}
                onClose={handleCloseContainerAccessDialog}
            >
                <DialogTitle>Accesso al container</DialogTitle>
                <DialogContent
                    style={{
                        overflow: "visible",
                        overflowY: "visible"
                    }}
                >
                    <ul>
                        <li style={{ display: "table-cell" }}>
                            <TextField
                                label="CLI"
                                value={cliCommand}
                                editable={false}
                                InputProps={{
                                    endAdornment: (
                                        <Tooltip title="Copia comando terminale">
                                            <Button
                                                color="primary"
                                                target="_blank"
                                                onClick={() => {
                                                    copy(cliCommand);
                                                    this.setState({
                                                        snackBar: true
                                                    });
                                                }}
                                            >
                                                <FileCopyOutlinedIcon />
                                            </Button>
                                        </Tooltip>
                                    )
                                }}
                            />
                        </li>
                        <li
                            style={{
                                display: "table-cell",
                                float: "left",
                                marginTop: "48px"
                            }}
                        >
                            <TextField
                                label="Web"
                                value={webCommand}
                                editable={false}
                                InputProps={{
                                    endAdornment: (
                                        <Tooltip title="Copia comando web">
                                            <Button
                                                color="primary"
                                                target="_blank"
                                                onClick={() => {
                                                    copy(webCommand);
                                                    this.setState({
                                                        snackBar: true
                                                    });
                                                }}
                                            >
                                                <FileCopyOutlinedIcon />
                                            </Button>
                                        </Tooltip>
                                    )
                                }}
                            />
                        </li>
                    </ul>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleCloseContainerAccessDialog}
                        color="primary"
                    >
                        <TranslatedText resource_name={"ra.actions.close"} />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    renderDBAccessDialog(data) {
        if (!this.state.showDB) {
            return null;
        }
        const handleCloseDBAccessDialog = () => {
            this.setState({
                showDB: false
            });
        };
        const cliCommand =
            "aws ssm start-session --target " +
            data.cluster_instance_id +
            ' --document-name "AWS-StartInteractiveCommand" --parameters "command=psql -h ' +
            data.rds_host +
            " -U " +
            data.rds_user +
            " " +
            data.rds_db_tse +
            '"';
        const webCommand =
            "psql -h " +
            data.rds_host +
            " -U " +
            data.rds_user +
            " " +
            data.rds_db_tse;
        return (
            <Dialog
                maxWidth={false}
                open={this.state.showDB}
                onClose={handleCloseDBAccessDialog}
            >
                <DialogTitle>Accesso al database</DialogTitle>
                <DialogContent
                    style={{
                        overflow: "visible",
                        overflowY: "visible"
                    }}
                >
                    <ul>
                        <li style={{ display: "table-cell" }}>
                            <TextField
                                label="CLI"
                                value={cliCommand}
                                editable={false}
                                InputProps={{
                                    endAdornment: (
                                        <Tooltip title="Copia comando terminale">
                                            <Button
                                                color="primary"
                                                target="_blank"
                                                onClick={() => {
                                                    copy(cliCommand);
                                                    this.setState({
                                                        snackBar: true
                                                    });
                                                }}
                                            >
                                                <FileCopyOutlinedIcon />
                                            </Button>
                                        </Tooltip>
                                    )
                                }}
                            />
                        </li>
                        <li
                            style={{
                                display: "table-cell",
                                float: "left",
                                marginTop: "48px"
                            }}
                        >
                            <TextField
                                label="Web"
                                value={webCommand}
                                editable={false}
                                InputProps={{
                                    endAdornment: (
                                        <Tooltip title="Copia comando web">
                                            <Button
                                                color="primary"
                                                target="_blank"
                                                onClick={() => {
                                                    copy(webCommand);
                                                    this.setState({
                                                        snackBar: true
                                                    });
                                                }}
                                            >
                                                <FileCopyOutlinedIcon />
                                            </Button>
                                        </Tooltip>
                                    )
                                }}
                            />
                        </li>
                    </ul>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDBAccessDialog} color="primary">
                        <TranslatedText resource_name={"ra.actions.close"} />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    handleCloseSnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        this.setState({
            snackBar: false
        });
    };

    render() {
        return (
            <React.Fragment>
                {this.props.data &&
                    this.props.permissions &&
                    (this.props.permissions.includes(
                        POLICY_INSTALLATIONS.GET_INFO
                    ) ||
                        this.props.permissions.includes(
                            POLICY_INSTALLATIONS.GET_LIMITED_INFO
                        ) ||
                        (this.props.data.installation_type_id ===
                            this.state.enterprise_id &&
                            this.props.permissions.includes(
                                POLICY_INSTALLATIONS.DATABASE_SUPPORT
                            ))) && (
                        <Button
                            color="primary"
                            target="_blank"
                            onClick={this.handleClickOpen}
                        >
                            <FormatListBulletedIcon
                                style={{ paddingRight: "0.4em" }}
                            />
                            DETTAGLI
                        </Button>
                    )}
                <Dialog
                    maxWidth={false}
                    open={this.state.open}
                    onClose={this.handleClose}
                >
                    <DialogTitle id="form-dialog-title">
                        <b>
                            {this.props.data
                                ? "Dettagli installazione " + this.props.data.id
                                : "Dati installazione non validi"}
                            {!this.state.loading &&
                                this.props.data.installation_type_id ===
                                    this.state.studio_id &&
                                this.props.permissions.includes(
                                    POLICY_INSTALLATIONS.GET_INFO
                                ) &&
                                this.renderSSHButtons(
                                    this.state.info.cluster_instance_id
                                )}
                            {!this.state.loading &&
                                this.props.data.installation_type_id ===
                                    this.state.studio_id &&
                                this.props.permissions.includes(
                                    POLICY_INSTALLATIONS.GET_INFO
                                ) &&
                                this.renderCopySSHCommand(
                                    this.state.info.cluster_instance_id
                                )}
                            {!this.state.loading &&
                                this.props.data.installation_type_id ===
                                    this.state.studio_id &&
                                (this.props.permissions.includes(
                                    POLICY_INSTALLATIONS.GET_INFO
                                ) ||
                                    this.props.permissions.includes(
                                        POLICY_INSTALLATIONS.GET_LIMITED_INFO
                                    )) &&
                                this.renderMoreOptionsMenu(this.state.info)}
                            {!this.state.loading &&
                                this.props.data.installation_type_id ===
                                    this.state.enterprise_id &&
                                this.props.permissions.includes(
                                    POLICY_INSTALLATIONS.DATABASE_SUPPORT
                                ) &&
                                this.renderEnterpriseAssistance()}
                        </b>
                    </DialogTitle>
                    <DialogContent
                        style={{
                            overflow: "visible",
                            overflowY: "visible"
                        }}
                    >
                        {this.state.loading && <CircularProgress />}
                        {!this.state.loading && this.myDialog()}
                        {!this.state.loading &&
                            this.props.data.installation_type_id ===
                                this.state.studio_id &&
                            this.renderContainerAccessDialog(this.state.info)}
                        {!this.state.loading &&
                            this.props.data.installation_type_id ===
                                this.state.studio_id &&
                            this.renderDBAccessDialog(this.state.info)}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            <TranslatedText
                                resource_name={"ra.actions.close"}
                            />
                        </Button>
                    </DialogActions>
                    <Snackbar
                        open={this.state.snackBar}
                        onClose={this.handleCloseSnackbar}
                        message="Comando copiato"
                        autoHideDuration={1000}
                    />
                </Dialog>
                <RefreshListActions
                    refreshInterval={
                        !this.state.open ? this.props.refreshInterval : null
                    }
                />
            </React.Fragment>
        );
    }
}

export default DetailsDialogButton;



// WEBPACK FOOTER //
// ./src/components/DetailsDialogButton.js